export const EMAIL_REGEX = /\S+@\S+\.\S+/
export const PASSWORD_REGEX = /^.{6,128}$/